import styled from 'styled-components/macro'

export const TotalTranAnker = styled.div`
  padding: 20px 0 10px 0;
  &:after {
    content: '';
    display: block;
    clear: both;
  }
`

export const TotalTran = styled.div`
  font-size: 14px;
  float: left;
`

export const TranNum = styled.span`
  padding-left: 0.1rem;
  color: #0097fe;
  font-weight: 600;
`
